const LinkItem = ({ href, name }) => (
  <a href={href}>
    {name} <span aria-hidden="true">&rarr;</span>
  </a>
);

export default LinkItem;